import { apiClient } from '../api/client'
import type { AxiosResponse } from 'axios'

export interface SpreadsheetParseResponse {
  success: boolean
  format_detected: string | null
  entries_count: number
  columns_detected: Record<string, string>
  warnings: string[]
  error: string | null
  ki_analysis_used: boolean
  uploaded_file_id: string | null
}

export interface SpreadsheetImportRequest {
  file_id: string
  column_mapping?: Record<string, string>
  template_id?: string
}

export interface SpreadsheetImportResponse {
  success: boolean
  structure_id: string | null
  entries_count: number
  warnings: string[]
  error: string | null
}

export interface SpreadsheetTemplateInfo {
  id: string
  name: string
  column_mapping: Record<string, string>
  format_hint: string | null
  created_at: string
  use_count: number
}

export interface SaveTemplateRequest {
  name: string
  column_mapping: Record<string, string>
  format_hint?: string | null
}

export const timetableSpreadsheetApi = {
  parseSpreadsheet: async (file: File): Promise<SpreadsheetParseResponse> => {
    const formData = new FormData()
    formData.append('file', file)
    const response: AxiosResponse<SpreadsheetParseResponse> = await apiClient.post(
      '/api/v1/timetable-spreadsheet/parse',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return response.data
  },

  importSpreadsheet: async (request: SpreadsheetImportRequest): Promise<SpreadsheetImportResponse> => {
    const response: AxiosResponse<SpreadsheetImportResponse> = await apiClient.post(
      '/api/v1/timetable-spreadsheet/import',
      request
    )
    return response.data
  },

  importFromUploadedFile: async (fileId: string, columnMapping?: Record<string, string>, templateId?: string): Promise<SpreadsheetImportResponse> => {
    const body: Record<string, any> = { file_id: fileId }
    if (columnMapping && Object.keys(columnMapping).length > 0) {
      body.column_mapping = JSON.stringify(columnMapping)
    }
    if (templateId) {
      body.template_id = templateId
    }
    const response: AxiosResponse<SpreadsheetImportResponse> = await apiClient.post(
      '/api/v1/timetable-spreadsheet/import-from-uploaded-file',
      new URLSearchParams(body).toString(),
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    )
    return response.data
  },

  saveTemplate: async (request: SaveTemplateRequest): Promise<SpreadsheetTemplateInfo> => {
    const response: AxiosResponse<SpreadsheetTemplateInfo> = await apiClient.post(
      '/api/v1/timetable-spreadsheet/templates',
      request
    )
    return response.data
  },

  listTemplates: async (): Promise<SpreadsheetTemplateInfo[]> => {
    const response: AxiosResponse<SpreadsheetTemplateInfo[]> = await apiClient.get(
      '/api/v1/timetable-spreadsheet/templates'
    )
    return response.data
  },

  deleteTemplate: async (templateId: string): Promise<void> => {
    await apiClient.delete(`/api/v1/timetable-spreadsheet/templates/${templateId}`)
  },
}
